import { useGlobalConfig }                from "context/GlobalContext"
import { useEffect, 
         useState 
       }                                  from "react"
import { Outlet }                         from "react-router"
import { ApplianceProfileAPI }            from "apis/applianceProfileAPI"
import { HomeProfileAPI }                 from "apis/homeProfileAPI"
import { CMSPilotApis }                   from "apis/cmsPilotAPI"
import { useDispatch, 
         useSelector 
       }                                  from "react-redux"
import { selectCMSInitDone, 
         selectCMSSelectedPilot, 
         setCMSPilotList, 
         setContentLimits, 
         setInitDone, 
         setLocales, 
       }                                  from "store/dataReducers/cmsPilotSlice"
import { setApplianceProfileMetadata 
       }                                  from "store/dataReducers/applianceProfileSlice"
import { setHomeProfileMetadata 
       }                                  from "store/dataReducers/homeProfileSlice"
import { Box }                            from "@mui/material"
import { BglLoading }                     from "components/loading/BglLoading"

export const CMSPilotLayout = () => {

  const { rc } = useGlobalConfig()
  const dispatch = useDispatch()

  const cmsInitDone = useSelector(selectCMSInitDone);
  const selectedPilot = useSelector(selectCMSSelectedPilot)
  const [error, setError] = useState<any>()
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    init()
  }, [])

  const init = async () => {

    setIsLoading(true)

    if (!cmsInitDone) {
      const error = await initCMSMetadata()
      if (error) {
        setError(error)
        setIsLoading(false)
        return
      }
    }

    const error = await initCMSPilotData()
    if (error) {
      setError(error)
      setIsLoading(false)
      return
    }

    setIsLoading(false)
  }

  const initCMSMetadata = async () : Promise<any> => {

    const [ apMetadataResp, hpAttributesResp, pilotsResp, localesResp, contentLimitsResp ] = await Promise.all([
      ApplianceProfileAPI.getApplianceProfileMetadata(rc),
      HomeProfileAPI.getHomeProfileAttributes(rc),
      CMSPilotApis.getPilots(rc),
      CMSPilotApis.getSupportedLocales(rc),
      CMSPilotApis.getContentLimits(rc)
    ])

    if (pilotsResp.error || hpAttributesResp.error || apMetadataResp.error || localesResp.error || contentLimitsResp.error) {
      return pilotsResp.error || hpAttributesResp.error || apMetadataResp.error || localesResp.error || contentLimitsResp.error
    }

    dispatch(setApplianceProfileMetadata(apMetadataResp.data))
    dispatch(setHomeProfileMetadata(hpAttributesResp.data))
    dispatch(setCMSPilotList(pilotsResp.data!))
    dispatch(setLocales(localesResp as any))
    dispatch(setContentLimits(contentLimitsResp.data!))
    dispatch(setInitDone(true))
  }

  const initCMSPilotData = async () : Promise<any> => {

    // Load saved Project specific CMS data
    const savedPilotId = localStorage.getItem('selectedPilotId')
    if (savedPilotId) {

      if (selectedPilot && selectedPilot.pilotId === savedPilotId) {
        return // No need to load the data again
      }

      const error = await rc.session.selectCMSPilotByPilotId(savedPilotId)
      return error
    }
  }

  return (
    <> 
      {isLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}><BglLoading /></Box>
        ) : error ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            Error: {error?.message}
          </Box>
        ) : (
          <Outlet />
        )}
    </>
  )
}